﻿export default class Verification {
    constructor() {
        this.dom = {
            $: window.$,
            $form: $('form'),
            $pwrule: $('li[data-regex]'),
            NextComponentLoaded: false
        };
        this.init();
    }

    init() {
        this.RefreshBankComponent();
        this.RefreshPartials();
        if (this.dom.$pwrule.length > 0) {
            this.PWrules();
        }
        //this.ActivatePhoneValidation();
        //this.initToggleInputFocus();        
        //Check box validation message in Polish
        $('.agree-1').on('change', function (e) {
            $('#agree-1-error').text($('#hdnErrorMessageId').val()).toggle(!$('.agree-1').prop('checked'))
            if ($('.agree-1').prop('checked')) {
                $('#verify-agree-error').hide();
            } else {
                if ($('#verify-agree-error').length > 0) {
                    $('#verify-agree-error').show();
                } else {
                    $(e.currentTarget).closest('.form-input-group').append('<span id="verify-agree-error" class="form-error">' + $('#hdnErrorMessageId').val() + '</span>');
                }
            }
        });
        //JS for biometric change
        if ($("#kyc-component").length) {
            $('#biometricVerifyButton').on('click', function (e) {
                if ($('#biometric-form').valid()) {
                    var onfidoBiometricInputType = {
                        "BiometricKycConsent": $('#biometricKycConsentChkBox:checkbox:checked').length > 0
                    };
                    $('#biometricVerifyButton').prop('disabled', true);
                    $(".loading-sceen").show();
                    getAjaxData("/api/sitecore/BiometricVerification/GetOnfidoBiometricResponse", "POST", false, onfidoBiometricInputType, function (data) {
                        if (data) {
                            //alert(data["OnfidoUrl"]);
                            if (data["OnfidoUrl"] != null) {
                                window.location = data["OnfidoUrl"];
                            }
                            else {
                                window.location.reload();
                            }
                        }
                        else {
                            window.location.reload();
                        }
                    });
                }
            });
            $('#biometricContinueButton').on('click', function (e) {                
                $('#biometricContinueButton').prop('disabled', true);
                $(".loading-sceen").show();
                var onfidoURL = $('#biometricContinueButton').data("continue-biometric");
                if (onfidoURL) {
                    window.location = onfidoURL;
                }
                else {
                    window.location.reload();
                }
            });
        }
        //JS for set-password step
        if ($("#setpassword-component").length) {
            $('#setpassword-btn').on('click', function (e) {
                if ($('#hdnUserEmail').val().length > 0) {
                    if ($("#set-pwd-veri-form").valid()) {
                        event.preventDefault();
                        var credentialsInputType = {
                            "LoginEmailAddress": $('#hdnUserEmail').val(),
                            "PWD": '',
                            "CheckCredentialsType": 'CHECK_EMAIL',
                            "ForgotPWDPage": true
                        };
                        $(".loading-sceen").show();
                        getAjaxData("/api/sitecore/Login/CheckUserCredentials", "POST", true, credentialsInputType, function (data) {
                            $('.reset-password-error-msg').hide();
                            if (data) {
                                if (!data.success && data.ErrorCode.trim().length > 0) {
                                    $(".loading-sceen").hide();
                                    $('.reset-password-error-msg').show();
                                }
                                else {
                                    if (data.LoginRegistrationScreenFlow == 'PASSWORD_ALREDY_SET') {
                                        window.location.reload();
                                    }
                                    else {
                                        GotoSetPassword(data.UserToken);
                                    }
                                }
                            }
                        });
                    }                    
                }        
            });
        }

        function GotoSetPassword(userToken) {
            var passwordInput = {
                "Email": $('#hdnUserEmail').val(),
                "Token": userToken,
                "Password": $('.password').val(),
                "Otp": '',
                "IsRequestFromVerifications": true
            };
            getAjaxData("/api/account/SetPassword", "POST", true, passwordInput, function (data) {
                $('.reset-password-error-msg').hide();
                if (data) {
                    if (data.isSuccess) {
                        $(".loading-sceen").hide();
                        $('.password-success-popup').show();
                        return false;
                    }
                    else {
                        $(".loading-sceen").hide();
                        $('.reset-password-error-msg').show();
                    }
                }                
            });
        }

        $('.content-popup-close').click(function (e) {
            $('.password-success-popup').hide();
            window.location.reload();
            return false;
        });
    }

    

    RefreshPartials() {

        // Checklist page - reload partial view every 30secs
        let refreshCount = 0;
        if ($('.verification-single').length > 0) {
            let refreshIntervalId = setInterval(() => {
                //Load all partials here

                if ($('.verification').hasClass('pauseRefresh')) {
                    //Pause partial refresh when BM popup is visible
                    refreshCount = 29;
                } else {
                    refreshCount += 1;
                    if (refreshCount == 30) {
                        var othercomponent = this.dom.NextComponentLoaded;
                        showPartial(othercomponent);
                        refreshCount = 0;
                    }
                }
            }, 1000);//interv
        }

        function showPartial(othercomponent) {

            var DataSrcId = $('#hdnVerificationPageID').val();
            var bankverificationstatus = $('#bankverificationStatus').val();
            $('.bankfailederror').hide();
            //var DataSourceId = {
            //    "DataSourceId": DataSrcId
            //};

            var partialrefreshinputtype = {
                "DataSourceId": DataSrcId,
                "BankStatus": bankverificationstatus
            };

            getAjaxData("/api/sitecore/Verification/GetPartialComponentToRefresh", "POST", false, partialrefreshinputtype, function (data) {
                if (data) {
                    if (data["KYC_DECLINED"] != null) {
                        window.location = data["KYC_DECLINED"];
                    }                    
                    if (data["RELOAD_STATUSES"] != null) {
                        location.reload(true);
                    }
                    if (data["BANK_VERIFICATION_FAILED"] != null) {
                        //All verification successfully completed, so go to thank you page
                        $('.bankfailederror').show();
                    }
                    if ($("#kyc-component").length && $("#setpassword-component").length) {
                        if (data["EMAIL"] != null && (data["PHONE"] != null || data["MOBILE"] != null) && (data["BANK"] != null || data["BANK_NA"] != null) && data["PESEL"] != null && data["KYC"] != null && data["ADDRESS"] != null && data["SETPASSWORD"] != null) {
                            //All verification successfully completed, so go to thank you page
                            location.reload(true);
                        }
                    }
                    else if ($("#kyc-component").length && !($("#setpassword-component").length)) {
                        if (data["EMAIL"] != null && (data["PHONE"] != null || data["MOBILE"] != null) && (data["BANK"] != null || data["BANK_NA"] != null) && data["PESEL"] != null && data["KYC"] != null && data["ADDRESS"] != null) {
                            //All verification successfully completed, so go to thank you page
                            location.reload(true);
                        }
                    }
                    else {
                        if (data["EMAIL"] != null && (data["PHONE"] != null || data["MOBILE"] != null) && data["BANK"] != null && data["PESEL"] != null) {
                            //All verification successfully completed, so go to thank you page
                            location.reload(true);
                        }
                    }
                    if ($('html').attr('lang') == 'ro') {
                        if (data["EMAIL"] != null && data["MOBILE"] != null) {
                            //All verification successfully completed, so go to thank you page
                            location.reload(true);
                        }
                    }
                    if (data["EMAIL"] != null) {
                        if ($("#email-component").length) {
                            $("#email-component").html($(data["EMAIL"])[0].outerHTML);
                        }
                    }
                    if (data["PHONE"] != null) {
                        if ($("#phone-component").length) {
                            $("#phone-component").html($(data["PHONE"])[0].outerHTML);
                        }
                    }
                    if (data["ADDRESS"] != null) {
                        if ($("#address-component").length) {
                            $("#address-component").html($(data["ADDRESS"])[0].outerHTML);
                        }
                    }
                    if (data["MOBILE"] != null) {
                        if ($("#phone-component").length) {
                            $("#phone-component").html($(data["MOBILE"])[0].outerHTML);
                        }
                    }
                    if (data["KYC"] != null) {
                        if ($("#kyc-component").length) {
                            $("#kyc-component").html($(data["KYC"])[0].outerHTML);
                        }
                    }
                    if (data["SETPASSWORD"] != null) {
                        if ($("#setpassword-component").length) {
                            $("#setpassword-component").html($(data["SETPASSWORD"])[0].outerHTML);
                        }
                    }
                    if (data["BANK"] != null) {
                        if ($("#bank-component").length) {
                            $("#bank-component").html($(data["BANK"])[0].outerHTML);
                            if (othercomponent) {
                                $(".verification-copy-standard").hide();
                                $('#js-refresh-component').hide();
                            }
                        }
                    }
                    if (data["PESEL"] != null) {
                        if ($("#pesel-component").length) {
                            $("#pesel-component").html($(data["PESEL"])[0].outerHTML);
                        }
                    }
                    if (data["NEXT_ITEM_TO_SHOW"] != null) {
                        var componentDIVName = '#' + data["NEXT_ITEM_TO_SHOW"] + '-component';
                        if ($(componentDIVName).length == 0) {
                            location.reload(true);
                        }
                    }
                }
            });
        }
    }

    RefreshBankComponent() {
        let thisDom = this.dom;
        var that = this;
        $("body").on("click", "#js-refresh-component", function (e) {
            /*$('#js-refresh-component').off('click').on('click', (e) => {*/
            e.preventDefault();
            $('.loading-screen').show(0, () => {

                $("#js-refresh-component").attr("disabled", "1");
                var DataSrcId = $('#hdnVerificationPageID').val();

                var DataSourceId = {
                    "DataSourceId": DataSrcId
                };

                getAjaxData("/api/sitecore/Verification/GetPartialComponent", "POST", true, DataSourceId, function (data) {
                    if (data) {
                        $(".verification-copy-standard").hide();
                        $('#js-refresh-component').hide();
                        if ($('#phone-component').length == 0) {
                            $(".verification").append(data.PartialView);
                        }
                        thisDom.NextComponentLoaded = true;
                        initToggleInputFocus();
                        ReloadValidation();
                    }
                });

            });
            $('.loading-screen').hide();
        });

        function ReloadValidation() {

            let $newField = $('.telephone');
            $.validator.addClassRules($newField.data('validator-id'),
                {
                    requiredvalidation: $newField.data("val-required"),
                    regex: $newField.data("val-regex")
                }
            );
            let opts = $.extend({ mask: $newField.data("val-mask-regex") }, $newField.data("val-mask-regex-obj"));
            new IMask($newField[0], opts);
            $newField.on('focus blur', (e) => {
                let $thisTel = $(e.currentTarget);
                $thisTel.parent().toggleClass('filled', $thisTel.val().length > 0).toggleClass('focus', document.activeElement === $thisTel[0]);
            });

            $('form').validate().destroy();
            $('form').validate({
                onkeyup: false,
                errorElement: 'span',
                errorClass: 'form-error',
                errorPlacement: (error, elem) => {
                    $("#" + error.attr("id")).remove();
                    elem.closest('.form-input-group').append(error);
                },
                submitHandler: (form) => {
                    $(form).find('.form-error-global').addClass('hidden');
                    //success so show processing icon
                    $('.loading-sceen').show();
                    return true;
                },
                invalidHandler: (elem) => {
                    $(elem.currentTarget).find('.form-err-info').attr('style', 'display:none;');
                    $(elem.currentTarget).find('.form-error-global').removeClass('hidden');
                },
                onfocusout: function (element) {
                    return this.element(element);
                }
            });
        }

        function initToggleInputFocus() {
            $(window).find()
            let $selectors = $('form').find("input[type=number]");

            $selectors
                .on('focus blur', toggleInputFocus.bind(this))
                .each((_, element) => {
                    toggleInputFocus(element);
                });
        }

        function toggleInputFocus(e) {
            if (!e) return;
            let $input = $(e.currentTarget ? e.currentTarget : e);
            let $parent = $input.parent();
            let $desiredElem = $parent.hasClass('eac-input-wrap') ? $parent.parent() : $parent;

            /** Trigger validation on autocomplete **/
            if (e.type === 'blur' && $input.prop('type') === 'email') {
                setTimeout(() => $input.trigger('focusout.validate', 200));
            }
            if ($parent.parent().hasClass('disabled')) {
                return;
            }

            $desiredElem
                .toggleClass('filled', $input.val().length > 0)
                .toggleClass('focus', document.activeElement === $input[0]);

            setTimeout(() => {
                $desiredElem.next('.input-results')
                    .toggleClass('hidden', document.activeElement !== $input[0]);
            }, 200);
        }

    }

    ActivatePhoneValidation() {
        let $newField = $('.telephone');
        $.validator.addClassRules($newField.data('validator-id'),
            {
                requiredvalidation: $newField.data("val-required"),
                regex: $newField.data("val-regex")
            }
        );
        let opts = $.extend({ mask: $newField.data("val-mask-regex") }, $newField.data("val-mask-regex-obj"));
        new IMask($newField[0], opts);
        $newField.on('focus blur', (e) => {
            let $thisTel = $(e.currentTarget);
            $thisTel.parent().toggleClass('filled', $thisTel.val().length > 0).toggleClass('focus', document.activeElement === $thisTel[0]);
        });
    }

    PWrules() {
        $('.password').on('keyup', () => {
            this.dom.$pwrule.each((id, liObj) => {
                var reg = new RegExp($(liObj).data('regex'));
                $(liObj).toggleClass('passed', reg.test($('.password').val())).toggleClass('failed', !reg.test($('.password').val()));
            });
        })
    }

}

document.addEventListener('DOMContentLoaded', () => new Verification());

    //******TESTING PURPOSE********DONT DELETE//
    //RefreshPartials() {
    //    $('#refresh').click(function () {
    //        var DataSrcId = $('#hdnVerificationPageID').val();
    //        var DataSourceId = {
    //            "DataSourceId": DataSrcId
    //        };
    //        getAjaxData("/api/sitecore/Verification/GetPartialComponentToRefresh", "POST", false, DataSourceId, function (data) {
    //            if (data) {
    //                if (data["EMAIL"] != null) {
    //                    if ($("#email-component").length) {
    //                        $("#email-component").html(data["EMAIL"]);
    //                    }
    //                }
    //                if (data["PHONE"] != null) {
    //                    if ($("#phone-component").length) {
    //                        $("#phone-component").html(data["PHONE"]);
    //                    }
    //                }
    //                if (data["BANK"] != null) {
    //                    if ($("#bank-component").length) {
    //                        $("#bank-component").html(data["BANK"]);
    //                    }
    //                }
    //                if (data["NEXT_ITEM_TO_SHOW"] != null) {
    //                    var componentDIVName = '#' + data["NEXT_ITEM_TO_SHOW"] + '-component';
    //                    if ($(componentDIVName).length == 0) {
    //                        location.reload(true);
    //                    }
    //                }
    //            }
    //        });
    //    });
    //}